import styled, { CSSObject } from "styled-components";
import { Popup } from "@swiggy-private/dls-web-core/dist/components/Popup";

export const PopupWidth = "calc(100% - 16px)";
export const PopupContainer = styled(Popup)(() => ({
    position: "relative" as CSSObject["position"],
    overflow: "hidden",
    border: "none",
}));

export const CloseIcon = styled.div<{ isSwiggyBlack: boolean }>(({ theme, isSwiggyBlack }) => ({
    width: "28px",
    height: "28px",
    borderRadius: "50%",
    backgroundColor: isSwiggyBlack
        ? theme.colors[theme.colorMode].text_inverse_Low_Emphasis
        : theme.colors[theme.colorMode].background_Secondary,
    position: "absolute",
    top: theme.spacing.small,
    right: theme.spacing.small,
    cursor: "pointer",
    zIndex: 1,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
}));
